module.exports = __webpack_public_path__ + "img/resp_text_small1.ca412b61.png";